import React, { useEffect } from "react";

import GreyTable from '../../../../components/Tables/GreyTable';
import { DlvQuality, resetDlvQuality } from '../../../../Redux/Slice/Grey/PartyProfile/PartyProfileSlice';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';

export const BillingQuality = ({ selectedProduction, selectedAccount }) => {

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  const dispatch = useDispatch();

  const { DlvQualityData } = useSelector((state) => state.PartyProfileSlice);

  useEffect(() => {
    dispatch(resetDlvQuality())
    dispatch(DlvQuality({
      selectedIds: selectedProduction ? selectedProduction.toString() : "",
      PARTYWISEIds: selectedAccount ? selectedAccount.toString() : ""
    }));
  }, [selectedProduction, selectedAccount]);

  const columns = [
    { key: "srNumber", label: "Sr. No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "ItemName", label: "QUALITY NAME", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Meter", label: "METER", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: true },
    { key: "Taka", label: "TAKA", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: true },
    { key: "Tp", label: "TP", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Rate", label: "AVG. RATE", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, align: "right" },
    { key: "Amount", label: "AMOUNT", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, align: "right" },
    { key: "SGST", label: "SGST", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, align: "right" },
    { key: "CGST", label: "CGST", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, align: "right" },
    { key: "Total", label: "TOTAL", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, align: "right" },
  ];

  const row = DlvQualityData?.DlvQuality?.map((row, index, arr) => ({
    //  srNumber: (index + 1).toString().padStart(arr.length.toString().length, "0"),
    id: index,
    ...row,
    Meter: row.Meter,
    Taka: row.Taka,
    Tp: row.Tp,
    Rate: row.Rate,
    Amount: row.Amount,
    Total: row.Total,
    SGST: row.SGST,
    CGST: row.CGST,
  }))

  if (DlvQualityData === null) {

    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }


  return (
    <div>
      <Row>
        <Col>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                color:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour8,
                padding: "14px",
              }}
            >
              <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight: "700" }}>
                BILLING QUALITY
              </h2>
            </div>
            <div><GreyTable columns={columns} data={row} iscolourDark={iscolourDark}
              iscolour={iscolour} /></div>
          </div>
        </Col>
      </Row>
    </div>
  )
}
